import { Distribution } from "../../types/Distribution";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

type UpdateInput = Partial<Distribution> & { id: string; updatedBy: string };

export const updateDistribution = async (input: UpdateInput): Promise<void> => {
  if (!input.id) {
    throw new Error("Community ID is required to update distribution");
  }

  const docRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(input.id)
    .collection(DB_PATH.DISTRIBUTION)
    .doc("credentials");

  const { id, ...payload } = input;

  const now = Date.now();
  const writePayload = {
    ...payload,
    updatedAt: now,
    createdAt: payload.createdAt ?? now,
  };

  try {
    await docRef.set(writePayload, { merge: true });
  } catch (error) {
    console.error("Error updating distribution", error);
    throw error;
  }
};
